<!-- 劳务公司里的函询表单组件 -->
<template>
  <div>
    <el-dialog
      title="函询"
      :visible.sync="dialogVisible"
      width="830px"
      :before-close="cancleClick"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <el-form
        class="dialogForm"
        label-position="right"
        label-width="100px"
        :model="formLabelAlign"
        :rules="rules"
        ref="ruleForm"
        @submit.native.prevent
      >
        <el-form-item
          v-if="isEnquiryTypeShow"
          label="函询类型："
          prop="enquiryType"
        >
          <div class="typeList">
            <ul class="clearfix">
              <li
                class="fl cursor"
                v-for="(item, index) in inquiryType"
                :key="index"
                @click="formLabelAlign.enquiryType = item.key"
                :class="{ active: formLabelAlign.enquiryType == index + 1 }"
              >
                <span>{{ item.val }}</span>
              </li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="疑问事项：" prop="questionMatters">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入最少5个字，最多200字"
            resize="none"
            maxlength="200"
            minlength="5"
            show-word-limit
            v-model="formLabelAlign.questionMatters"
            :autosize="{ minRows: 4, maxRows: 8 }"
          ></el-input>
        </el-form-item>
        <el-form-item label="我的理解：">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="最多输入200字"
            resize="none"
            maxlength="200"
            show-word-limit
            v-model="formLabelAlign.comprehend"
            :autosize="{ minRows: 4, maxRows: 8 }"
          ></el-input>
        </el-form-item>
        <el-form-item label="请求答复：">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="最多输入200字"
            resize="none"
            maxlength="200"
            show-word-limit
            v-model="formLabelAlign.requestAnswer"
            :autosize="{ minRows: 4, maxRows: 8 }"
          ></el-input>
        </el-form-item>
        <div
          class="formLi"
          v-for="(ele, inx) in formLabelAlign.customFieldList"
          :key="inx"
        >
          <div class="liTitle">
            <el-input
              v-model="ele.fieldKey"
              maxlength="10"
              placeholder="请输入内容"
              class="addInput"
            ></el-input>
          </div>
          <div class="liForm">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="最多输入200字"
              v-model="ele.fieldValue"
              maxlength="200"
              resize="none"
              show-word-limit
              :autosize="{ minRows: 4, maxRows: 8 }"
            ></el-input>
            <i
              class="el-icon-remove-outline deleteItemLi"
              @click="deleteItemLi(inx)"
            ></i>
          </div>
        </div>

        <el-form-item class="addDomain">
          <el-button icon="el-icon-plus" @click="addDomain">新增</el-button>
          <span class="notes"
            >最多新增5个字段，标题最多输入10字，内容最多输入200字</span
          >
        </el-form-item>
        <el-form-item class="upload" label="上传附件：" prop="filedList">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :on-success="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :limit="5"
            :on-exceed="handleExceed"
            :file-list="formLabelAlign.filedList"
            :accept="accepts"
          >
            <el-button @click="uploadFileClick($event)">上传附件</el-button>
            <div slot="tip" class="el-upload__tip">
              支持扩展名：.rar .zip .doc .docx .pdf
              .jpg，最多上传5个文件，每个大小不超过10Mb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleClick">取 消</el-button>
        <el-button
          class="confirm-button"
          type="primary"
          :loading="disabled"
          @click="confirmClick"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
const userApi = process.env.VUE_APP_APIUSER
export default {
  data() {
    return {
      disabled: false,
      formLabelAlign: {
        siteNo: "",
        questionMatters: "",
        comprehend: "",
        requestAnswer: "",
        customFieldList: [],
        filedList: [],
        enquiryType: 1,
        receiveDTO: {
          answerUserType: 0
        }
      },
      rules: {
        enquiryType: [
          {
            required: true,
            message: "请选择函询类型",
            trigger: "change"
          }
        ],
        questionMatters: [
          {
            required: true,
            message: "请输入最少5个字，最多200字",
            trigger: "change"
          },
          {
            min: 5,
            max: 200,
            message: "长度在 5 到 200 个字符",
            trigger: "change"
          }
        ]
      },
      teamUrl: process.env.VUE_APP_LOGINAPI,
      uploadUrl: `${userApi}/file/add`,
      accepts: ".rar, .zip, .doc, .docx, .pdf, .jpg"
    }
  },
  props: {
    dialogVisible: {
      //控制dialog显示隐藏
      type: Boolean
    },
    dialogType: {
      // 0为招标 1为竞价
      type: Number
    },
    //函询类型
    inquiryType: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 访问网站的类型
    siteType: {
      type: [Number, String],
      default: -1
    }
  },
  computed: {
    isEnquiryTypeShow() {
      return this.siteType === 0 || this.siteType === 1
    }
  },
  methods: {
    clearForm() {
      this.formLabelAlign = this.$options.data().formLabelAlign
      this.disabled = false
    },
    //报错时关闭loading
    closeLoading() {
      this.disabled = false
    },
    cancleClick() {
      // this.$refs['ruleForm'].resetFields()
      this.$emit("closeDialog", false)
    },
    //确认按钮
    confirmClick() {
      this.$refs["ruleForm"].validate(async valid => {
        if (valid) {
          for (let i = 0; i < this.formLabelAlign.customFieldList.length; i++) {
            if (
              !(
                this.formLabelAlign.customFieldList[i].fieldKey &&
                this.formLabelAlign.customFieldList[i].fieldValue
              )
            ) {
              this.$message({
                type: "warning",
                message: "新增标题与内容需全部填写"
              })
              return
            }
          }
          let arr = []
          for (let i = 0; i < this.formLabelAlign.filedList.length; i++) {
            let obj = {
              name: this.formLabelAlign.filedList[i].name,
              fileUrl: this.formLabelAlign.filedList[i].response.data
            }
            arr.push(obj)
          }
          if (!this.isEnquiryTypeShow) {
            delete this.formLabelAlign.enquiryType
          }
          let dataObj = {
            ...this.formLabelAlign
          }
          dataObj.filedList = arr
          this.disabled = true
          this.cancleClick("ruleForm")
          this.$emit("confirmDialog", dataObj)
        } else {
          this.disabled = false
          return false
        }
      })
    },
    deleteItemLi(index) {
      this.formLabelAlign.customFieldList.splice(index, 1)
    },
    addDomain() {
      if (this.formLabelAlign.customFieldList.length == 5) {
        this.$message({
          type: "warning",
          message: "最多只可以添加五条"
        })
        return
      }
      this.formLabelAlign.customFieldList.push({
        fieldKey: "",
        fieldValue: ""
      })
    },
    handleRemove(file, filedList) {
      this.formLabelAlign.filedList = filedList
    },
    handlePreview(response, file, filedList) {
      this.formLabelAlign.filedList = filedList
      this.$message({
        message: "文件上传成功",
        type: "success"
      })
    },
    handleExceed(files, filedList) {
      this.$message.warning(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + filedList.length
        } 个文件`
      )
    },
    beforeRemove(file, filedList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    uploadFileClick(event) {
      if (this.formLabelAlign.fileList.length === 5) {
        this.$message({
          type: "warning",
          message: "最多只可以添加五条"
        })
        event.stopPropagation()
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.typeList {
  ul {
    display: flex;
    justify-content: left;
    align-items: center;
    li {
      width: 60px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      margin-right: 10px;
      margin-top: 4px;
      &:hover {
        color: #0286df;
      }
      &:last-child {
        margin-right: 0 !important;
      }
    }
    .active {
      border: 0px;
      color: #0286df;
      background: rgba(2, 134, 223, 0.15);
      &:hover {
        color: #0286df;
      }
    }
  }
}
.formLi {
  clear: both;
  margin-bottom: 15px;
  .liTitle {
    float: left;
    width: 120px;
    overflow: hidden;
    .addInput {
      width: 110px;
    }
  }
  .liForm {
    float: left;
    position: relative;
    width: calc(100% - 150px);
    margin-bottom: 22px;
    .deleteItemLi {
      display: inline-block;
      height: 20px;
      width: 20px;
      font-size: 20px;
      color: red;
      position: absolute;
      z-index: 9;
      top: calc(50% - 10px);
      right: -30px;
      cursor: pointer;
    }
  }
}
.confirm-button {
  margin-left: 20px;
}
.el-upload__tip {
  line-height: 19px;
  color: #c0c4cc;
}
.upload {
  margin-bottom: 0px;
}
.addDomain,
.upload {
  /deep/.el-button {
    border: 1px solid #0286df;
    color: #0286df;
  }
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
/deep/.el-dialog__footer {
  text-align: center;
  padding-bottom: 40px;
}
.notes {
  margin-left: 10px;
  color: #c0c4cc;
  font-size: 14px;
}
/deep/ .el-form-item {
  clear: both;
}
/deep/ .el-textarea .el-input__count {
  background: none;
}
/deep/.el-form-item__label {
  color: #333333;
}
</style>
